import { postStartSalesforceImport } from '@api';

import { AMPLITUDE_EVENT, createLogSagaWithFn } from '@sonar-software/sonar-analytics';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const importsSalesforceStartPostSlice = createPostAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSagaWithFn(() => ({
				data: { type: 'Salesforce' },
				id: AMPLITUDE_EVENT.SYNC_STARTED
			})),
			type: SagaYieldType.Every
		}
	],
	name: 'ImportsSalesforceStart',
	receive: true,
	request: true,
	requestHandler: postStartSalesforceImport
});
